export default __webpack_public_path__ + "static/media/202.2d388c59.jpg";